module.exports = __webpack_public_path__ + "videos/Gpt-Slow.d221712.mp4";